import styled from "styled-components";
import { motion } from "framer-motion";

export const SCard = styled(motion.article)`
    color: ${props => props.theme.colors.white};
    width: 100%;
    height: 100%;
    border: 1.5px solid #29292e;
    padding: 2rem 0;
    border-radius: 1rem;
    max-width: 25rem;
    p{
        font-size:1rem;
        text-align: justify;
        margin-top: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
        @media screen and (max-width: 700px){
            text-align: center;
        }
    }
    div{
        position:relative;

        h2{
            font-size: 1.1rem;
            max-width: 90%;
            padding-left: 1rem;
            padding-right: 1rem;
            @media screen and (max-width: 700px){
                text-align: center;
                margin: 0 0 0.5rem 0;
                max-width: 100%;

            }
        }

        div.date{
            color: ${props => props.theme.colors.tertiary};
            padding-left: 1rem;
            padding-right: 1rem;
            font-size: 0.8rem;
            margin-bottom: 0.5rem;

            @media screen and (max-width: 700px){
                text-align: center;
            }
        }
    }
       
`
